import {
  INSTANCE_FATDI_OPTIONS_READ_META,
} from 'client/redux/fatdi/constants';
import { instanceFatdiReadMeta } from 'client/redux/fatdi/actionCreators';

export const instanceFatdiOptionsReadMeta = instanceId => dispatch => dispatch(instanceFatdiReadMeta(INSTANCE_FATDI_OPTIONS_READ_META, instanceId));
